import { createAction, props } from '@ngrx/store';
import { IAuthSession, IFeatureFlagsPermissions } from '@redngapps/feature-flags/data-access';

export const login = createAction('[Feature Flags Auth] Login');
export const loginSuccess = createAction(
  '[Feature Flags Auth] Login Success',
  props<{ session: IAuthSession; permissions: IFeatureFlagsPermissions }>(),
);
export const loginFailure = createAction('[Feature Flags Auth] Login Failure', props<{ error: string }>());

export const logout = createAction('[Feature Flags Auth] Logout');
export const logoutSuccess = createAction('[Feature Flags Auth] Logout Success');
export const logoutFailure = createAction('[Feature Flags Auth] Logout Failure', props<{ error: string }>());
